import _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const GROWTH_RECORDS_LIST_SUCCESS = api.events.growthRecordsList.actionSuccess;
const GROWTH_RECORDS_LATEST_SUCCESS = api.events.growthRecordsLatest.actionSuccess;
const GROWTH_RECORDS_CREATE_SUCCESS =
  api.events.growthRecordsPost.actionSuccess;
const GROWTH_RECORDS_PATCH_SUCCESS =
  api.events.growthRecordsPatch.actionSuccess;
const GROWTH_RECORDS_DELETE_SUCCESS =
  api.events.growthRecordsDelete.actionSuccess;

const growthRecordSchema = new schema.Entity('growthRecords');

const growthRecordListSchema = new schema.Array(growthRecordSchema);

const defaultState = {};

export default function(state = defaultState, action) {
  switch (action.type) {
    case GROWTH_RECORDS_LIST_SUCCESS: {
      const normalizedData = normalize(action.data, growthRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.growthRecords
      };
    }
    case GROWTH_RECORDS_LATEST_SUCCESS: {
      const normalizedData = normalize(action.data, growthRecordListSchema);

      return {
        ...state,
        ...normalizedData.entities.growthRecords
      };
    }
    case GROWTH_RECORDS_CREATE_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case GROWTH_RECORDS_PATCH_SUCCESS: {
      return {
        ...state,
        [action.data.id]: action.data
      };
    }
    case GROWTH_RECORDS_DELETE_SUCCESS: {
      const deletedId = action.request.pathvars.id;
      return _.omit(state, [deletedId]);
    }
    case LOGOUT_SUCCESS:
      return defaultState;
    default:
      return state;
  }
}
